export const gateNames = {
  credentialingSaas: 'admin_saas_credentials',
  facilityRateAcknowledgement: 'fg_facility_rate_acknowledgement',
  blockCreateNewRateSettings: 'fg_block_create_new_rate_settings',
  blockPostShifts: 'fg_block_post_shifts',
  autoGeneratedRatesReview: 'fg_auto_generated_rates_review',
  basePayRateAutomation: 'fg_base_pay_rate_automation',
  disableMarkupsForW2LocalAssignments: 'fg_disable_markups_for_w2_local_assignments',
};
